/**
 * The Admin Console's section tabs: user management at `/admin`, the scoped
 * audit history at `/admin/history` (DEV-5969).
 *
 * Rendered only inside the `/admin/*` routes, which already sit behind the
 * `Cyngn-Admin` guard and `ADMIN_CONSOLE_ENABLED`, so the history entry point
 * inherits the same gating as the rest of the console.
 */
import React, { FC, memo } from "react";
import { Link } from "react-router-dom";

import { AdminTabsStyled } from "./styles";

export const ADMIN_USERS_PATH = "/admin";
export const ADMIN_HISTORY_PATH = "/admin/history";

export type AdminConsoleTab = "users" | "history";

const TABS: ReadonlyArray<{ id: AdminConsoleTab; text: string; to: string }> = [
  { id: "users", text: "Users", to: ADMIN_USERS_PATH },
  { id: "history", text: "History", to: ADMIN_HISTORY_PATH },
];

export const AdminConsoleTabs: FC<{ active: AdminConsoleTab }> = memo(
  ({ active }) => (
    <AdminTabsStyled data-test-id="admin_tabs">
      {TABS.map(({ id, text, to }) =>
        id === active ? (
          <span key={id} aria-current="page" data-test-id={`admin_tab_${id}`}>
            {text}
          </span>
        ) : (
          <Link key={id} data-test-id={`admin_tab_${id}`} to={to}>
            {text}
          </Link>
        )
      )}
    </AdminTabsStyled>
  )
);
